/** Resource types offered in the activity-feed "All types" filter, in display
 *  order. Shared by the header popover and the /activity-feed page so both
 *  offer the same choices. */
export const NOTIFICATION_FILTER_RESOURCE_TYPES: {
  value: string;
  labelKey: string;
}[] = [
  { value: 'CERTIFICATE', labelKey: 'resourceTypes.CERTIFICATE' },
  { value: 'AUDITS', labelKey: 'resourceTypes.AUDITS' },
  { value: 'DOCUMENTS', labelKey: 'resourceTypes.DOCUMENTS' },
  { value: 'QUESTIONNAIRES', labelKey: 'resourceTypes.QUESTIONNAIRES' },
  { value: 'CAPA', labelKey: 'resourceTypes.CAPA' },
  { value: 'CASCADE-MAPPING', labelKey: 'resourceTypes.CASCADE_MAPPING' },
  {
    value: 'COLLABORATIVE-PRODUCT-MAPPING',
    labelKey: 'resourceTypes.COLLABORATIVE-PRODUCT-MAPPING',
  },
  { value: 'ENTITY-SCREENING', labelKey: 'resourceTypes.ENTITY_SCREENING' },
  { value: 'TRACING', labelKey: 'resourceTypes.TRACING' },
  { value: 'REPORTS', labelKey: 'resourceTypes.REPORTS' },
  { value: 'SLCP', labelKey: 'resourceTypes.SLCP' },
  { value: 'COMPANIES', labelKey: 'resourceTypes.COMPANIES' },
  { value: 'ORDERS', labelKey: 'resourceTypes.ORDERS' },
];

export const RESOURCE_TYPE_META: Record<
  string,
  { key: string; cssVar: string }
> = {
  COMPANIES: {
    key: 'resourceTypes.COMPANIES',
    cssVar: '--resource-companies',
  },
  DOCUMENTS: {
    key: 'resourceTypes.DOCUMENTS',
    cssVar: '--resource-documents',
  },
  CERTIFICATE: {
    key: 'resourceTypes.CERTIFICATE',
    cssVar: '--resource-certificate',
  },
  MEMBERSHIP: {
    key: 'resourceTypes.MEMBERSHIP',
    cssVar: '--resource-membership',
  },
  BADGE: { key: 'resourceTypes.BADGE', cssVar: '--resource-badge' },
  AUDITS: { key: 'resourceTypes.AUDITS', cssVar: '--resource-audits' },
  TRACING: { key: 'resourceTypes.TRACING', cssVar: '--resource-tracing' },
  'SUPPLIER-NETWORK-SHARING': {
    key: 'resourceTypes.SUPPLIER-NETWORK-SHARING',
    cssVar: '--resource-network-sharing',
  },
  'RISK-ANALYSIS': {
    key: 'resourceTypes.RISK-ANALYSIS',
    cssVar: '--resource-risk-analysis',
  },
  CAPA: { key: 'resourceTypes.CAPA', cssVar: '--resource-capa' },
  QUESTIONNAIRES: {
    key: 'resourceTypes.QUESTIONNAIRES',
    cssVar: '--resource-questionnaires',
  },
  'CASCADE-MAPPING': {
    key: 'resourceTypes.CASCADE-MAPPING',
    cssVar: '--resource-cascade-mapping',
  },
  'COLLABORATIVE-PRODUCT-MAPPING': {
    key: 'resourceTypes.COLLABORATIVE-PRODUCT-MAPPING',
    cssVar: '--resource-product-mapping',
  },
  REPORTS: { key: 'resourceTypes.REPORTS', cssVar: '--resource-reports' },
  SLCP: { key: 'resourceTypes.SLCP', cssVar: '--resource-slcp' },
  'ENTITY-SCREENING': {
    key: 'resourceTypes.ENTITY-SCREENING',
    cssVar: '--resource-entity-screening',
  },
  'CERTIFIED-MATERIALS': {
    key: 'resourceTypes.CERTIFIED-MATERIALS',
    cssVar: '--resource-certified-materials',
  },
  // The product and BOM bulk-import notifications are stamped `PRODUCTS`, and
  // `styles-bulk-import-completed` splits between `PRODUCTS` and `STYLES`.
  // Without entries here `NotificationItem` renders no badge at all rather
  // than falling back to one.
  PRODUCTS: { key: 'resourceTypes.PRODUCTS', cssVar: '--resource-products' },
  STYLES: { key: 'resourceTypes.STYLES', cssVar: '--resource-styles' },
  // `company-linked` writes its trigger id into the resource-type column
  // instead of a real type; alias it onto the Companies badge.
  'company-linked': {
    key: 'resourceTypes.COMPANIES',
    cssVar: '--resource-companies',
  },
  ORDERS: { key: 'resourceTypes.ORDERS', cssVar: '--resource-orders' },
};
